
const isTrustNetInstalled = ()=> {
    const caClient = document.getElementById('TrustNETCAClient');
    if (caClient != null
        && typeof caClient.object !== 'undefined'
        && caClient.object != null)
    {
        return true;
    }

    const unet = document.getElementById('unetTS');
    if (unet != null
        && typeof unet.object !== 'undefined'
        && unet.object != null) {
        return true;
    }

    return false;
};

const getImeiPasswordRulesText = () => {
    let rules = [
        'Minimum length is 10',
        'Must be different from the previous',
        'Must be alphanumeric with at least one special character',
        'Allowed special characters are ! @ # $ ^ * ? _ ~',
        '3 consecutive numbers or characters is not allowed.',
        'A repetition of same character 4 times or more is not allowed.',
    ];
    let ruleNum = 1;
    return rules.map(rule => `${ruleNum++}) ${rule}`).join('<br>');
};

// Returns true if valid. returns error String if not valid.
const isValidImeiPassword = (password, loginId = '', email = '', name = '') => {
    const strNewPassword = password;
    const strUserID = loginId;

    // PART
    const strName = name;
    const nowDate = new Date();
    const year = String(nowDate.getYear());
    const year_prev = String(nowDate.getYear() - 1);
    const year_next = String(nowDate.getYear() + 1);

    let strEmailId = '';
    let strEmailCompany = '';

    const idx_email_id = email.indexOf('@');
    if (idx_email_id > -1) {
        strEmailId = email.substring(0, idx_email_id);
        const idx_email_company = email.indexOf('.');
        if (idx_email_company > -1) {
            strEmailCompany = email.substring(idx_email_id + 1, idx_email_company);
        }
    }

    // FULL
    const FORBIDDEN_WORDS = [
        strUserID.toUpperCase(),
        ...strName.toUpperCase().split(' '),
        'SAMSUNG',
        'GSPN',
        'SERVICE',
        'SERVICIO',
        'IMEI',
        'ESN',
        'PASSWORD',
        year,
        year_prev,
        year_next,
        strEmailId.toUpperCase(),
        strEmailCompany.toUpperCase(),
        '1QAZXSW23E',
        '12QWERASDF',
        '12QWASZX3E',
        'ASDFQWER12',
        'ASDF',
        'QWER',
        'ZXCV',
    ];

    // console.log('FWORDS', FORBIDDEN_WORDS);

    const RULES = [
        {
            check: password => !password,
            msg: 'The ESN/IMEI password is required.',
        },
        {
            check: password => password.length < 10,
            msg: 'The password must be 10 or more characters.',
        },
        {
            check: password => !password.match(/([a-zA-Z].[0-9])|([0-9].[a-zA-Z])/),
            msg: 'The password must be alphanumeric',
        },
        {
            check: password => password.match(/([&,%,>,<,',",;,},{,|])/),
            msg: 'The password cannot contain the following special characters. e.g. & % > < \' " ; } { |',
        },
        {
            check: password => !password.match(/([!,@,#,$,^,*,?,_,~])/),
            msg: 'The password must contain one of the following special characters. e.g. ! @ # $ ^ * ? _ ~',
        },
        {
            check: password => {
                const passwordUpperCase = password.toUpperCase();
                for (let i = 0; i < FORBIDDEN_WORDS.length; i++) {
                    if (!FORBIDDEN_WORDS[i]) continue;
                    if (passwordUpperCase.includes(FORBIDDEN_WORDS[i])) {
                        return `The password cannot contain a word "${FORBIDDEN_WORDS[i]}"`;
                    }
                }
                return false;
            },
            msg: '',
        },
        {
            check: password => {
                let samePassword_0 = 0; //동일문자 카운트
                let samePassword_1 = 0; //연속성(+) 카운트
                let samePassword_2 = 0; //연속성(-) 카운트

                let chr_pass_0, chr_pass_1, chr_pass_2, chr_pass_3;
                const passwordLength = password.length;

                for (let i = 0; i < passwordLength; i++) {
                    chr_pass_0 = password.charAt(i);
                    chr_pass_1 = password.charAt(i + 1);
                    chr_pass_2 = password.charAt(i + 2);
                    chr_pass_3 = password.charAt(i + 3);

                    //동일문자 카운트
                    if (chr_pass_0 == chr_pass_1 && chr_pass_0 == chr_pass_2 && chr_pass_0 == chr_pass_3) {
                        samePassword_0++;
                    }

                    //연속성(+) 카운드
                    if (
                        chr_pass_0.charCodeAt(0) - chr_pass_1.charCodeAt(0) == 1 &&
                        chr_pass_1.charCodeAt(0) - chr_pass_2.charCodeAt(0) == 1
                    ) {
                        samePassword_1++;
                    }

                    //연속성 역순(-) 카운드
                    if (
                        chr_pass_0.charCodeAt(0) - chr_pass_1.charCodeAt(0) == -1 &&
                        chr_pass_1.charCodeAt(0) - chr_pass_2.charCodeAt(0) == -1
                    ) {
                        samePassword_2++;
                    }
                }

                if (samePassword_0 > 0) {
                    return 'A repetition of same character 4 times or more is not allowed. (i.e. 1111, aaaa).';
                }

                if (samePassword_1 > 0 || samePassword_2 > 0) {
                    return 'Consecutive numbers or characters not allowed. (i.e. 123, abc).';
                }

                return false;
            },
            msg: '',
        },
    ];

    // const title = 'Password Rule';
    let result = true; // if not valid, returns Msg String
    RULES.every(rule => {
        const invalid = rule.check(strNewPassword); // invalid: Boolean | String
        if (invalid) {
            const msg = typeof invalid === 'string' ? invalid : rule.msg;
            result = msg;
            // SDLUtil.alert({ title, msg });
            return false; // Stops the loop
        }
        return true;
    });

    return result;
};

export default {
    isTrustNetInstalled,
    getImeiPasswordRulesText,
    isValidImeiPassword,
};


// WEBPACK FOOTER //
// ./src/utils/CertUtil.js